import InputNumber from 'rc-input-number';
import { useDispatch, useSelector } from 'react-redux';
import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';

export function OperatorSla() {
  const dispatch = useDispatch();

  const {
    configuration: { sla },
  } = useSelector((state) => state.operators);

  const updateSla = (sla) => {
    dispatch({ type: OperatorsActions.configuration, payload: { sla } });
  };

  return (
    <OperatorField title="SLA" description="Expected order shipment SLA from vendor (in days)">
      <InputNumber
        onChange={updateSla}
        min={1}
        max={100}
        onBlur={(e) => {
          if (isNaN(e.target.value) || e.target.value === '') {
            updateSla(0);
          }
        }}
        onFocus={(e) => e.target.select()}
        onClick={(e) => e.target.select()}
        value={sla}
        step={1}
        precision={0}
      />
    </OperatorField>
  );
}
